import { css } from '@inter-ikea-kompis/web-component';
export default class PillGroupCarouselStyle {
    /**
     * Returns styles.
     *
     * @param options Options holder.
     * @param options.theme Theme.
     * @returns Styles.
     */
    static getStyle(options) {
        const { spacing } = options.theme;
        return css `
			kompis-carousel {
				display: flex;
				flex-wrap: nowrap;
			}
			kompis-carousel-item {
				flex-shrink: 0;
				padding: ${spacing.space75 / 16 / 2}rem 0;
			}
			kompis-pill {
				margin-right: ${spacing.space200 / 16 / 2}rem;
			}
			::-webkit-scrollbar {
				width: 0;
				background: transparent;
				height: 0;
			}
		`;
    }
}
//# sourceMappingURL=PillGroupCarouselStyle.js.map